import React from 'react';
import { CustomLayoutProps } from '../../../types/summarizer';

const SummarizerLayout: React.FC<CustomLayoutProps> = ({ config, children, className = '' }) => {
  // Apply custom styles from config
  const containerStyles = config.ui?.customStyles?.container;
  const primaryColor = config.ui?.primaryColor || '#3b82f6';
  const theme = config.ui?.theme || 'light';

  return (
    <div
      className={`summarizer-layout tubeonai-widget ${className} ${containerStyles || ''}`}
      style={
        {
          '--primary-color': primaryColor,
          '--secondary-color': config.ui?.secondaryColor || primaryColor,
        } as React.CSSProperties
      }
      data-theme={theme}
      data-tool-id={config.id}
      data-tool-category={config.category}
    >
      {/* Tool Container */}
      <div
        className={`
        summarizer-container space-y-10
        ${config.ui?.compactMode ? 'compact' : 'normal'}
        ${theme === 'dark' ? 'dark' : 'light'}
        bg-white rounded-lg shadow-sm border border-gray-200 p-3 sm:!p-6
        ${config.ui?.customStyles?.container || ''}
      `}
      >
        {children}
      </div>
    </div>
  );
};

export default SummarizerLayout;
